import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './BizInput.css';
import { themes } from '../../utils/globals';

class BizInput extends Component {
  handleChange = (event) => {
    const { onChange, type } = this.props;
    const { value } = event.target;
    if (onChange) {
      if (type === 'number') {
        const floatVal = parseFloat(value);
        if (Number.isNaN(floatVal)) onChange(null);
        else onChange(floatVal);
      } else {
        onChange(value);
      }
    }
  };

  handleBlur = () => {
    const { value, onChange, type } = this.props;
    if (type === 'number' && value === null) {
      onChange(0);
      return;
    }
    if (value === '') {
      onChange(null);
    }
  };

  render() {
    const { type, theme, name, placeholder, style, value, disabled, textareaRows } = this.props;
    let valueToShow = value;
    if (value === null) valueToShow = '';
    if (type === 'textarea') {
      return (
        <textarea
          name={name}
          rows={textareaRows}
          className={theme ? `biz-input biz-input-theme-${theme}` : 'biz-input'}
          onChange={this.handleChange}
          value={valueToShow}
          placeholder={placeholder}
          style={style}
          disabled={disabled}
        />
      );
    }
    return (
      <input
        name={name}
        type={type}
        className={theme ? `biz-input biz-input-theme-${theme}` : 'biz-input'}
        value={valueToShow}
        onChange={this.handleChange}
        placeholder={placeholder}
        style={style}
        disabled={disabled}
        onBlur={this.handleBlur}
      />
    );
  }
}

// BizInput.getDerivedStateFromProps = (nextProps, prevState) => {
//   if (nextProps.value && prevState.value !== nextProps.value) {
//     return {
//       value: nextProps.value,
//     };
//   }
//   return null;
// };

BizInput.propTypes = {
  theme: PropTypes.oneOf(themes),
  type: PropTypes.oneOf(['text', 'number', 'password', 'textarea']),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  placeholder: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  textareaRows: PropTypes.number,
};

BizInput.defaultProps = {
  theme: null,
  type: 'text',
  placeholder: null,
  style: null,
  disabled: false,
  textareaRows: 3,
  value: null,
};

export default BizInput;



// WEBPACK FOOTER //
// ./src/components/UI/BizInput.jsx